var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import styled from '@emotion/styled';
import { color, boxShadow, textAlign, justifyContent, display, maxWidth, } from 'styled-system';
import { Flex } from '../../common/components/Flex';
import { Grid } from '../../common/components/Grid';
import { UspCtaLink } from './UspCtaLink';
import { UspHeader } from './UspHeader';
import { UspItem } from './UspItem';
var MAX_LAYOUT_WIDTH_EVEN = ['250px', '500px', null, '1000px'];
var MAX_LAYOUT_WIDTH_ODD = ['250px', null, '750px'];
var UspTeaserGrid = styled(Grid)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"])), color, boxShadow, justifyContent, textAlign, display);
UspTeaserGrid.defaultProps = {
    textAlign: 'center',
    bg: 'gray.14',
    color: 'text',
    boxShadow: ['0 2px 6px 0 rgba(192, 192, 192, 0.5)', 'none'],
    display: 'flex',
    justifyContent: 'center',
};
var UspLayout = styled(Flex)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), maxWidth);
UspLayout.defaultProps = {
    flexDirection: ['column', 'row'],
    alignItems: ['center', 'flex-start'],
    justifyContent: 'center',
    flexWrap: 'wrap',
    width: '100%',
};
var CommonUspTeaser = function (_a) {
    var title = _a.title, subtitleHtml = _a.subtitleHtml, items = _a.items, ctaLinkLabel = _a.ctaLinkLabel, ctaLinkHref = _a.ctaLinkHref, backgroundColor = _a.backgroundColor, textColor = _a.textColor, __legacy_shop_reboot_max_width = _a.__legacy_shop_reboot_max_width;
    var containerMaxWidth = items.length % 2 === 0 ? MAX_LAYOUT_WIDTH_EVEN : MAX_LAYOUT_WIDTH_ODD;
    var hasCta = ctaLinkLabel && ctaLinkHref;
    return (React.createElement(UspTeaserGrid, { "data-testid": "usp-teaser-container", legacyShopRebootMaxWidth: __legacy_shop_reboot_max_width, bg: backgroundColor, color: textColor },
        React.createElement(UspHeader, { title: title, subtitleHtml: subtitleHtml }),
        React.createElement(UspLayout, { maxWidth: containerMaxWidth }, items.map(function (props, index) { return (React.createElement(UspItem, __assign({}, props, { key: index }))); })),
        hasCta && (React.createElement(UspCtaLink, { ctaLinkLabel: ctaLinkLabel, ctaLinkHref: ctaLinkHref }))));
};
CommonUspTeaser.defaultProps = {
    __legacy_shop_reboot_max_width: true,
};
export default CommonUspTeaser;
var templateObject_1, templateObject_2;
